"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper class provides ability to set custom EventSource instance
 */
class SSEBuilder {
    constructor(factory) {
        this._factory = factory;
    }
    createInstance(url, options) {
        return this._factory(url, options);
    }
    /**
     * Get or create new instance of SSEBuilder
     * @param sseInstance
     * @returns SSEBuilder
     */
    static getInstance(sseInstance) {
        if (!SSEBuilder.instance) {
            SSEBuilder.instance = new SSEBuilder(sseInstance);
        }
        return SSEBuilder.instance;
    }
}
exports.default = SSEBuilder;
//# sourceMappingURL=EventSourceBuilder.js.map